<template>
    <b-modal
        body-class="p-0"
        cancel-disabled
        hide-footer
        id="change-date-modal"
        ok-disabled
        title="">
        <div class="modal-body modal-body-lg pt-0">
            <h4 class="text-center">
                Change booking date
            </h4>
        </div>
        <div class="modal-body modal-body-lg pt-0">

            <!-- Loading -->
            <div class="col-12" v-if="showDateLoader">
                <loading-state></loading-state>
                <h4 v-if="Object.keys(this.orderAvailability).length === 0" class="mb-4 text-center">Loading available dates, please wait...</h4>
                <h4 v-if="dayIsBeingSelected" class="mb-4 text-center">We're currently updating your repair date (this can take 5-10 seconds)...</h4>
            </div>

            <!-- Date updated -->
            <div class="empty-state pt-3" role="alert" v-if="selectedDay">
                <animated-success class="empty-icon"></animated-success>
                <h3 class="mb-4">Your repair date has been updated to {{ selectedDay.week_day }} {{ selectedDay.full_date }}</h3>
                <button class="btn btn-outline-primary btn-block btn-lg" @click="closeModal()">Close</button>
            </div>

           <!-- Reason box -->
            <div v-if="!showDateLoader && !selectedDay">
              <div class="col-12">
                <h4 class="text-center">
                  Please Specify Why You Would Like To Make This Change.
                </h4>
               <textarea @input="checkReason" class="form-control" v-model="reason"/>
              </div>
            </div>
            <!-- List of dates -->
            <div v-if="!showDateLoader && !selectedDay && reasonGiven">
                <div class="col-12">
                    <div class="alert alert-danger" v-if="Object.keys(errors).length !== 0">
                        <animated-error size="md" class="mr-2"></animated-error>
                        <div class="alert-content">
                            {{ errors[0] }}
                        </div>
                    </div>
                    <p class="text-muted text-sm">
                        <i class="fa fa-info-circle"></i> We send your time slot at 18:00 on the evening before your repair.
                    </p>
                    <div class="card-list flex-column mb-0">
                        <div class="selectable-card"
                             v-for="(day, index) in orderAvailability"
                             :key="index"
                             :class="{ 'disabled' : !day.available, 'active' : day.selected }"
                             @click="daySelected(day)">
                            <div class="card-body justify-content-between">
                                <p>
                                    {{ day.week_day }} {{ day.full_date }}
                                </p>
                                <p>
                                    <template v-if="day.available">Available</template>
                                    <template v-if="!day.available">Fully Booked</template>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </b-modal>
</template>

<script>
    import {mapActions, mapGetters} from "vuex"

    export default {
        props: ["order"],

        data() {
            return  {
                dayIsBeingSelected: false,
                errors: false,
                selectedDay: null,
                showDateLoader: true,
                reasonGiven: false,
                reason: null,
            }
        },

        created() {
            this.fetchOrder();
        },

        computed: {
            ...mapGetters(["orderAvailability"]),

        },

        methods: {
            ...mapActions([
                "changeOrderDate",
                "loadOrderAvailability"
            ]),


            /** check reason to show date */
            checkReason() {
              this.reasonGiven = this.reason.split(" ").length > 3
            },

            /** Close the modal and set selected day to false */
            closeModal() {
                this.dayIsBeingSelected = false;
                this.showDateLoader = false;
                this.selectedDay = null;
                this.$bvModal.hide('change-date-modal');
                this.$emit('dateChanged');
            },

            /** Fetch list of available dates */
            fetchOrder() {
                this.showDateLoader = true;
                this.loadOrderAvailability({
                    order: this.order.booking.order_id
                }).then(() => {
                    this.showDateLoader = false;
                });
            },

            /** A day has been selected */
            daySelected(day) {
                this.errors = [];

                if (!day.available) {
                    return;
                }

                this.orderAvailability.forEach(day => {
                    day.selected = false;
                });

                day.selected = true;

                this.showDateLoader = true;
                this.dayIsBeingSelected = true;
              let logData = {
                jobId: this.order.job.id,
                userId: null,
                original_date: this.order.booking.booking_date,
                new_date: day.date,
                reason: this.reason,
                original_technician: this.order.booking.technician_id,
                new_technician: this.order.booking.technician_id,
              };
                this.changeOrderDate({
                    day: day.date,
                    order: this.order,
                    logData: logData,
                }).then(() => {
                    this.selectedDay = day;
                    this.showDateLoader = false;
                    this.dayIsBeingSelected = false;
                    this.$emit('dateChanged');
                }).catch(error => {
                    this.showDateLoader = false;
                    if (error.response && error.response.data.code === "OR04") {
                        this.errors = error.response.data.messages[0];
                        return;
                    }
                    this.closeModal();
                    this.$emit('dateChanged');
                })
            }
        }
    }
</script>

<style scoped>

</style>